import { Menu, Bell, Search } from 'lucide-react';
import { SJAvatar } from '@/components/shared/sj-avatar';
import { useAuth } from '@/providers/auth-provider';

interface SJAdminHeaderProps {
  onMenuToggle: () => void;
}

export function SJAdminHeader({ onMenuToggle }: SJAdminHeaderProps) {
  const { user } = useAuth();

  return (
    <header className="flex h-14 items-center justify-between border-b border-[var(--sj-border)] bg-[var(--sj-surface)] px-4">
      <div className="flex items-center gap-3">
        <button
          onClick={onMenuToggle}
          className="flex h-8 w-8 items-center justify-center rounded-[6px] text-[var(--sj-text-muted)] hover:bg-[var(--sj-bg)] lg:hidden"
        >
          <Menu className="h-4 w-4" />
        </button>
        <div className="relative hidden sm:block">
          <Search className="absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-[var(--sj-text-muted)]" />
          <input
            type="text"
            placeholder="Search admin..."
            className="h-8 w-56 rounded-[8px] border border-[var(--sj-border)] bg-[var(--sj-bg)] pl-8 pr-3 text-xs text-[var(--sj-text-primary)] placeholder:text-[var(--sj-text-muted)] focus:border-[#de4c49] focus:outline-none focus:ring-1 focus:ring-[#de4c49]/20"
          />
        </div>
      </div>

      <div className="flex items-center gap-3">
        <button className="relative flex h-8 w-8 items-center justify-center rounded-[6px] text-[var(--sj-text-muted)] hover:bg-[var(--sj-bg)] hover:text-[var(--sj-text-primary)] transition-colors">
          <Bell className="h-4 w-4" />
          <span className="absolute -right-0.5 -top-0.5 flex h-4 w-4 items-center justify-center rounded-full bg-[#de4c49] text-[9px] font-bold text-white">
            3
          </span>
        </button>
        <div className="flex items-center gap-2">
          <SJAvatar name={user?.name ?? user?.email ?? 'Admin'} size="sm" />
          {user?.name && (
            <span className="hidden text-xs font-medium text-[var(--sj-text-primary)] md:block">
              {user.name}
            </span>
          )}
        </div>
      </div>
    </header>
  );
}
